import React from "react";
import DataEncryption from "./misc/DataEncryption";
import PageLayout from "../../../components/Layout/PageLayout";

const DataEncrypPage: React.FC = () => {
  return (
    <PageLayout>
      <DataEncryption />
    </PageLayout>
  );
};

export default DataEncrypPage;
